export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5916.fd4110f3.jpg";